/**
 * Settings Component
 * 
 * @package TopBuddy
 */

import { CheckboxControl, PanelBody, PanelRow, Button, NoticeList } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const Settings = ({ isPro, roles, accessRoles, onAccessRolesChange, onSave, isSaving, notices, onRemoveNotice }) => {
	const handleRoleChange = (role, checked) => {
		let newAccessRoles = [...accessRoles];
		if (checked) {
			newAccessRoles.push(role);
		} else {
			newAccessRoles = newAccessRoles.filter((r) => r !== role);
		}
		onAccessRolesChange(newAccessRoles);
	};

	return (
		<div className="topbuddy-settings-container">
			{isPro && (
				<PanelBody title={__('Permissions', 'topbuddy')}>
					<p>{__('Select which user roles can access and manage TopBuddy.', 'topbuddy')}</p>
					<div className="topbuddy-roles-list">
						{Object.entries(roles).map(([role, label]) => (
							<PanelRow key={role}>
								<CheckboxControl
									label={label}
									checked={accessRoles.includes(role)}
									onChange={(checked) => handleRoleChange(role, checked)}
									disabled={role === 'administrator'} // Admin should always have access
								/>
							</PanelRow>
						))}
					</div>
				</PanelBody>
			)}

			<div className="topbuddy-settings-footer">
				<Button
					variant="primary"
					onClick={onSave}
					isBusy={isSaving}
					disabled={isSaving}
				>
					{__('Save Settings', 'topbuddy')}
				</Button>
				{notices.length > 0 && (
					<NoticeList
						notices={notices}
						onRemove={onRemoveNotice}
						className="topbuddy-settings-notices"
					/>
				)}
			</div>
		</div>
	);
};

export default Settings;
